import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormComponent, IFormDialogData } from 'src/app/shared/form/form.component';
import { SampleMedia } from 'src/app/models/sampleMedia.model';
import {
  TextFormField,
  NumberFormField,
  ToggleFormField,
  SingleSelectionFormField,
} from 'src/app/shared/form/formField.model';
import nameOf from 'src/app/shared/form/nameOf.helper';
import { SampleMediaService } from 'src/app/services/sample-media.service';
import { PhaseEnum } from 'src/app/enums/phase.enum';
import { TypeService } from 'src/app/services/type.service';
import { MediaTypeEnum } from 'src/app/enums/mediaType.enum';

@Component({
  standalone: false,
  selector: 'app-sample-media-dialog',
  templateUrl: './../../shared/form/form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./../../shared/form/form.component.scss']
})
export class SampleMediaDialogComponent extends FormComponent<SampleMedia> implements OnInit {

  constructor(
    dialogRef: MatDialogRef<SampleMediaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
    sampleMediaService: SampleMediaService,
    protected injector: Injector,
    private typeService: TypeService
  ) {
    super(dialogRef, sampleMediaService, data, 'Sample Media', injector);
  }

  ngOnInit(): void {
    this.isFormLoading = true;
    this.getEntity().subscribe({
      next: (entity) => {
        this.entity = entity;
        this.initFields();
        this.isFormLoading = false;
      },
      error: (error) => {
        this.toastService.showError(error);
        this.isFormLoading = false;
      }
    });
  }

  getNewObject(): SampleMedia {
    return new SampleMedia();
  }

  validate(): boolean {
    return true;
  }

  initFields(): void {
    this.fields = [
      new TextFormField({
        property: nameOf<SampleMedia>(x => x.name),
        name: 'Name'
      }),
      new SingleSelectionFormField({
        property: nameOf<SampleMedia>(x => x.mediaType),
        name: 'Media Type',
        required: false,
        options: this.typeService.getEnumOptions(MediaTypeEnum)
      }),
      new TextFormField({
        property: nameOf<SampleMedia>(x => x.manufacturer),
        name: 'Manufacturer',
        required: false,
      }),
      new NumberFormField({
        property: nameOf<SampleMedia>(x => x.poreSizeMicrons),
        name: 'Pore Size (µm)',
        required: false,
      }),
      new NumberFormField({
        property: nameOf<SampleMedia>(x => x.diameterMM),
        name: 'Diameter (mm)',
        required: false,
      }),
      new TextFormField({
        property: nameOf<SampleMedia>(x => x.sorbentMaterial),
        name: 'Sorbent Material',
        required: false,
      }),
      new SingleSelectionFormField({
        property: nameOf<SampleMedia>(x => x.phase),
        name: 'Phase',
        required: false,
        options: this.typeService.getEnumOptions(PhaseEnum),
      }),
      new NumberFormField({
        property: nameOf<SampleMedia>(x => x.recommendedFlowRateSccm),
        name: 'Flow Rate (sccm)',
        required: false,
      }),
      new TextFormField({
        property: nameOf<SampleMedia>(x => x.usageNotes),
        name: 'Usage Notes',
        required: false,
      }),
      new ToggleFormField({
        property: nameOf<SampleMedia>(x => x.isActive),
        name: 'Is Active'
      })
    ];
  }
}
